import type {
  IAddTemporarilyRequest,
  IMappers,
  TAddTemporarilyResponse,
} from '../../common/repositories/encrypted-file-manager/v2/add-temporarily';
import { HttpTimeoutError, UnknownError } from '@cian/peperrors/shared';
// eslint-disable-next-line no-duplicate-imports
import {
  createAddTemporarilyModel,
  defaultConfig,
} from '../../common/repositories/encrypted-file-manager/v2/add-temporarily';
import { convertObjectToFormData, createURL } from './utils';
import { IConfig } from '@cian/config/shared';
import { IAddFileResponse } from '../../common/repositories/encrypted-file-manager/entities/Models/AddFileResponse';

export interface IUploadFileOptions<TResponse200> {
  config: IConfig;
  mappers?: IMappers<TResponse200>;
  parameters: IAddTemporarilyRequest;
  onProgress: (event: ProgressEvent<XMLHttpRequestEventTarget>) => void;
}

export async function uploadFile<TResponse200>({
  config,
  mappers,
  parameters,
  onProgress,
}: IUploadFileOptions<TResponse200>): Promise<TAddTemporarilyResponse | TResponse200> {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    const stringUri = createURL({
      model: createAddTemporarilyModel(parameters),
      config,
    }).toString();
    const body = convertObjectToFormData(parameters);

    xhr.addEventListener('load', () => {
      if (mappers && xhr.status in mappers) {
        if (xhr.status === 200) {
          resolve(mappers[200](xhr.response as IAddFileResponse, {} as Headers));
        }
      }

      resolve({
        statusCode: xhr.status,
        response: xhr.response,
        headers: {},
      } as TAddTemporarilyResponse);
    });

    xhr.addEventListener('timeout', () => {
      reject(
        new HttpTimeoutError(
          `Microservice ${defaultConfig.microserviceName} api ${stringUri} not answers in ${xhr.timeout} milliseconds`,
          `http-api.request-timeout.${defaultConfig.microserviceName}`,
        ),
      );
    });

    xhr.addEventListener('error', () => {
      reject(
        new UnknownError({
          message: `Microservice encrypted-file-manager api ${defaultConfig.apiType} request error`,
          domain: `http-api.request-error.${defaultConfig.microserviceName}`,
          details: {
            readyState: xhr.readyState,
            status: xhr.status,
            statusText: xhr.statusText,
          },
        }),
      );
    });

    xhr.responseType = 'json';
    xhr.upload.addEventListener('progress', onProgress);
    xhr.open('POST', stringUri, true);
    xhr.send(body);
  });
}
